import customConnect from '../customConnect';
import { urlToProps, propsToUrl } from './urlParser';
import { panZoom } from '../map/actions';
import { drawFeaturesChange, toggleActive } from '../draw/actions';
import { updateURL, cleanURL } from '../urlRouting/actions';
import { switchBaseLayer } from '../baseLayers/actions';
import { default_zoom, default_coords } from '../config';
import { map } from '../map/map';
import { VECTOR_BASE_LAYER } from '../baseLayers/reducer';

var stateObj = {};
var onLoadFin = false;
var urlUpdatedFnc = null;


window.onpopstate = function(event) {

	if(typeof urlUpdatedFnc == 'function') {

		urlUpdatedFnc(urlToProps(window.location.pathname));
	}
};

var stateUpdateHandler = function(props) {
	
	if (typeof props.logoStatus !== 'undefined' && props.logoStatus) {
		console.log('url cleaning');
	//	props.urlClean();
	}

	var strURL = propsToUrl(props);

	if(strURL !== window.location.pathname && onLoadFin){

		history.pushState(stateObj, "bm", strURL);
		props.urlStringChange(strURL);
	}
	
	urlUpdatedFnc = props.urlUpdated;

//	window.onload = function(event) {
	if(	!onLoadFin ) {
		console.log('ONLOAD');

		var pathname = window.location.pathname;

		props.urlUpdated(urlToProps(pathname));
		onLoadFin = true;
	}
//	}
};

export default function (store) { //new props and action function

	const mapStateToPropsRes = (state) => {

		return {
		//	routingProfile: state.routing.profile,
			mapCoords: state.map.coords,
			mapZoom: state.map.zoom,
			features: state.draw.featuresGeoJSON.features,
		//	routing: state.routing.enabled,
		//	waypoints: state.routing.waypoints,
		//	speedCameras: state.speedCameras.enabled,
		//	traffic: state.traffic.enabled,
		//	baseLayers: state.baseLayers.active,
		//	labelLayer: state.dataLayers.labelLayer,
		//	poiLayer: state.dataLayers.poiLayer,
		//	admDivisionLayer: state.dataLayers.admDivisionLayer,
		//	embed: state.embed.active,
		//	logoStatus: state.mainPanel.logoOpened,
		//	search: (typeof state.search.currentlySelected.centerCoords !== 'undefined' ? state.search.currentlySelected.centerCoords : [])
		};
	};

	const mapDispatchToPropsRes = (dispatch) => {

		return {
			urlClean: () => {
				dispatch(cleanURL());
			},
			urlStringChange: (url) => {
				dispatch(updateURL(url));
			},
			urlUpdated: (props) => {
				//console.log('urlUpdated',props);
				//MetaInfoUpdater(props);
				if(typeof props.baseLayers !== 'undefined') {
					dispatch(switchBaseLayer(props.baseLayers));
				}

				if(typeof props.mapCoords !== 'undefined') {

					dispatch(panZoom({updateSource: 'URL', coords: props.mapCoords, zoom: parseInt(props.mapZoom)}));
				} else {
					dispatch(panZoom({updateSource: 'URL', coords: default_coords, zoom: default_zoom}));
				}

				if(typeof props.features !== 'undefined') {

					var geojsonObject = {
						type: 'FeatureCollection',
						features: props.features
					};

					dispatch(toggleActive(true));

					dispatch(drawFeaturesChange({GeoJSON: geojsonObject, updateSource: 'URL' }));
					dispatch(panZoom({coords: props.mapCoords, zoom: props.mapZoom}));
				} else {
					var geojsonObject = {type: 'FeatureCollection',	features: []};

					dispatch(toggleActive(false));
					dispatch(drawFeaturesChange({GeoJSON: geojsonObject, updateSource: 'URL' }));
				}
			}
		};
	};

	

	customConnect(mapStateToPropsRes, mapDispatchToPropsRes, store, stateUpdateHandler);
}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/urlRouting/urlContainer.js